import { Paper, Stack, styled } from "@mui/material";
import { InternalLink } from "../../InternalLink";
import { MuiImage } from "../../MuiImage";
import { BodyTextM, BodyTextXS } from "../../Typography";

export const QuestionnaireQuestionAnswerPaper = styled(Paper)(({ theme }) =>
    theme.unstable_sx({
        my: theme.spacing(4),
        p: theme.spacing(3),
    }),
);

export const QuestionnaireQuestionImageStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "row",
        alignItems: "start",
        flexWrap: "wrap",
        gap: theme.spacing(4),
        mt: theme.spacing(2),
    }),
);

export const QuestionnaireQuestionImage = styled(MuiImage)(({ theme }) =>
    theme.unstable_sx({
        flex: "1 0 0px",
        width: { xs: "100%", sm: "50%" },
        mt: theme.spacing(2),
    }),
);

export const QuestionnaireQuestionBodyTextXS = styled(BodyTextXS)(({ theme }) =>
    theme.unstable_sx({
        flex: "1 0 0px",
        mb: theme.spacing(2),
        "& h3:first-of-type": {
            mt: theme.spacing(0),
            mb: theme.spacing(2),
        },
        "& p": {
            mt: theme.spacing(0),
            mb: theme.spacing(3),
        },
    }),
);

export const QuestionnaireQuestionAnswerLabel = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        transform: "none",
        marginBottom: theme.spacing(2),
        color: theme.palette.grey["800"],

        "&.Mui-focused": {
            color: theme.palette.grey["600"],
        },
    }),
);

export const QuestionnaireRejectMessageBodyTextM = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        my: theme.spacing(6),
    }),
);

export const QuestionnaireRejectMessageLink = styled(InternalLink)(({ theme }) =>
    theme.unstable_sx({
        textDecoration: "underline",
        cursor: "pointer",
    }),
);
